import React from 'react'
import { analyticsCurrentAction } from '@store/atoms'
import { useAtomValue } from 'jotai'
import { useAnalytics } from './use-analytics.hook'
import { fncGlobaleConsole, SetAdobiAnalytics } from '@utils/utility'
import { useLocation } from 'react-router-dom'

export type AnalyticsAction =
	| 'none'
	| 'Step00'
	| 'Step10'
	| 'Step11'
	| 'Step20'
	| 'Step30'
	| 'Step40'
	| 'Step50'
	| 'Step01'
	| 'Step02'
	| 'Step05'
	| 'StepAllegaDocumenti'
	| 'StepChangeToDesktop'
	| 'StepChangeToTablet'
	| 'StepFotografaDocumenti'
	| 'StepServizi'
	| 'StepVerificaDati'
	| 'ThankYou'
	| 'TnkYou_AllegaDocumenti'
	| 'TnkYou_FotografaDocumenti'
	| 'TnkYouNOallega'
	| 'TnkYouOKFine'
	| 'TnkYouOKnoAll'
	| 'TnkYouOKnoIBAN'
	| 'TnkYouOKnoAllnoIBAN'
	| 'Step0'
	| 'Step1'
	| 'Step12'
	| 'Step2'
	| 'Step3'
	| 'Step4'
	| 'Step5'
	


export const Analytics = () => {

	const location = useLocation();
	const page = location.pathname.split("/")[1];

	const currentStep = useAtomValue(analyticsCurrentAction)
	useAnalytics()

	const name = 'iccrea_name'

	React.useEffect(() => {
		if (currentStep && currentStep !== 'none') {
			SetAdobiAnalytics('iccrea_name')
			fncGlobaleConsole('Adobe Launch var ' + name)
		}
	}, [currentStep])
	
	if (currentStep !== 'none') {
		return (
			<iframe
				width='1'
				height='1'
				style={{
					border: 'none',
					opacity: 0,
					pointerEvents: 'none',
					position: 'absolute',
				}}
				src={`${
					import.meta.env.VITE_PREVENTIVATORE
				}/Pagine/Analytics/${page}/${currentStep}.aspx`}
			/>
		)
	}

	return null
}
